
const TokenKey = "Admin-Token";
const NameKey = "Admin-Name";
const RolesKey = "Admin-Roles";
const WebsocketKey = "Admin-Id";
const SingleNavigation = "SingleNavigation";
const CompleteNavigation = "CompleteNavigation";

export function getToken() {
  return localStorage.getItem(TokenKey);
}

export function setToken(token) {
  return localStorage.setItem(TokenKey, token);
}

export function removeToken() {
  return localStorage.removeItem(TokenKey);
}

export function getName() {
  return localStorage.getItem(NameKey);
}

export function setName(name) {
  return localStorage.setItem(NameKey, name);
}

export function setAdminId(id) {
  return localStorage.setItem(WebsocketKey, id);
}

export function getAdminId() {
  return localStorage.getItem(WebsocketKey);
}

export function setNavigation(m) {
  return localStorage.setItem(SingleNavigation, m);
}

export function getNavigation() {
  return localStorage.getItem(SingleNavigation);
}

//
export function setCompleteNavigation(list) {
  return localStorage.setItem(CompleteNavigation, list);
}

export function getCompleteNavigation() {
  return localStorage.getItem(CompleteNavigation);
}



export function removeName() {
  return localStorage.removeItem(NameKey);
}

export function getRoles() {
  return localStorage.getItem(RolesKey);
}

export function setRoles(roles) {
  return localStorage.setItem(RolesKey, roles);
}

export function removeRoles() {
  return localStorage.removeItem(RolesKey);
}

// ========== 企微客服 userId 缓存 ==========
const ContactUserIdKey = "QW-Contact-UserId";
// 后端授权失败时可能返回的无效值
const INVALID_CONTACT_IDS = ['getuseridfail', 'undefined', 'null', ''];

function isValidContactUserId(userId) {
  return userId && !INVALID_CONTACT_IDS.includes(userId.toLowerCase());
}

export function getContactUserId(corpid) {
  const key = corpid ? `${ContactUserIdKey}:${corpid}` : ContactUserIdKey;
  const val = localStorage.getItem(key);
  // 读取时也校验，自动清理历史脏数据
  if (val && !isValidContactUserId(val)) {
    localStorage.removeItem(key);
    return null;
  }
  return val;
}

export function setContactUserId(userId, corpid) {
  if (!isValidContactUserId(userId)) {
    console.warn('[localStorage] 拒绝缓存无效的 contact_userid:', userId);
    return;
  }
  const key = corpid ? `${ContactUserIdKey}:${corpid}` : ContactUserIdKey;
  return localStorage.setItem(key, userId);
}

export function removeContactUserId() {
  return localStorage.removeItem(ContactUserIdKey);
}
